export const actions = {
  set_state: 'product/set_state',
  get_product: 'product/get_product',
  delete_product: 'product/delete_product',
  get_confirm_product: 'product/get_confirm_product',
  accepted_product: 'product/accepted_product',
  rejected_product: 'product/rejected_product',
  get_activity: 'product/get_activity'
}
